import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { useFadeIn } from './useFadeIn';

const STATS = [
  { value: 700, suffix: '+', label: 'Campaigns' },
  { value: 200, suffix: '+', label: 'Influencers' },
  { value: 30,  suffix: '+', label: 'Brands' },
  { value: 1000, suffix: '+', label: 'Content Pieces' },
];

export default function StatsBar() {
  const { ref: inViewRef, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const ref = useFadeIn();

  return (
    <section data-testid="stats-section" className="stats-bar">
      <div ref={inViewRef} className="stats-bar-inner">
        {STATS.map((s, i) => (
          <div
            key={i}
            data-testid="stat-counter-item"
            className="stat-bar-item"
          >
            <div className="stat-bar-number">
              {inView ? (
                <CountUp end={s.value} duration={2.2} useEasing />
              ) : (
                <span>0</span>
              )}
              <span className="stat-bar-suffix">{s.suffix}</span>
            </div>
            <div className="stat-bar-label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
